import { Controller } from "@hotwired/stimulus"

// Scrolls its element into view on arrival, when asked to.
//
// The World's post sits at the foot of the page, below the map and the
// errands. A friend's "Send a parcel" and the post's own answers both come
// back here, and a URL fragment cannot be relied on to bring the eye down:
// Turbo follows a form's redirect by fetch, and fetch drops the fragment. So
// the server says `reveal` in the markup and the element brings itself up.
export default class extends Controller {
  static values = { on: Boolean }

  connect() {
    if (!this.onValue) return

    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    requestAnimationFrame(() => {
      this.element.scrollIntoView({ block: "start", behavior: reduced ? "auto" : "smooth" })
    })
  }
}
